const SERVICES = [
  {
    img: 'https://cdn1.npcdn.net/npimg/1710323937_c7526d74ece85fddff5aa6c210e77cfe.jpeg?md5id=2ce979e120151e3689bebafd4b1a9f9b&new_width=10000&new_height=10000&type=3&w=',
    title: 'PERSONAL MAKEUP CLASS 个人彩妆班',
  },
  {
    img: 'https://cdn1.npcdn.net/npimg/1709522852_a5f4e2ca3a2dfb891d0013ce9949d5e3.jpeg?md5id=2ce979e120151e3689bebafd4b1a9f9b&new_width=10000&new_height=10000&type=3&w=',
    title: 'PROFESSIONAL MASTERCLASS 专业造型班',
  },
  {
    img: 'https://cdn1.npcdn.net/npimg/1706781199_375e2cd44c118b1729aef464b240dfcf.jpeg?md5id=2ce979e120151e3689bebafd4b1a9f9b&new_width=10000&new_height=10000&type=3&w=',
    title: 'KOL (Key Opinion Leader) | Influencer Makeup & Hair Styling 网红造型和发型设计',
  },
  {
    img: 'https://cdn1.npcdn.net/npimg/1706781161_5f5f74a10016481645f122299d3f6028.jpeg?md5id=2ce979e120151e3689bebafd4b1a9f9b&new_width=10000&new_height=10000&type=3&w=',
    title: 'SFX Makeup | Special Effects Makeup 特效妆容',
  },
  {
    img: 'https://cdn1.npcdn.net/npimg/1706781216_79250a037716219bb56863aa7b984c46.jpeg?md5id=2ce979e120151e3689bebafd4b1a9f9b&new_width=10000&new_height=10000&type=3&w=',
    title: 'Brands Campaign / Catalog Shoot 品牌宣传 / 目录拍摄',
  },
  {
    img: 'https://cdn1.npcdn.net/npimg/1710258237_28de90fd3b7a39cdeaf046197ec1bd25.jpeg?md5id=2ce979e120151e3689bebafd4b1a9f9b&new_width=10000&new_height=10000&type=3&w=',
    title: 'Bridal Makeup & Hair Styling 新娘造型',
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="py-10 sm:py-16 bg-white">
      <div className="text-center mb-8 sm:mb-10 px-4">
        <h2 className="text-3xl sm:text-4xl text-gray-800" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          Our Services
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
        {SERVICES.map((service, i) => (
          <div key={i} className="relative overflow-hidden group cursor-pointer" style={{ aspectRatio: '4/3' }}>
            <img
              src={service.img}
              alt={service.title}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/60 transition-all duration-300 flex items-center justify-center px-6">
              <h3 className="text-white text-lg sm:text-xl font-semibold text-center leading-snug opacity-0 group-hover:opacity-100 transition-opacity duration-300 scale-90 group-hover:scale-100 transform">
                {service.title}
              </h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
